import axios from "@/api/api.js";
import store from "../store/index.js";
import $public from "./public.js";

export default {
  uploadVideo(params) {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_upladHost + "/api/media/upload_video", params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  uploadImg_dir(params, obj) {
    params.random = Math.random();
    return new Promise((resolve, reject) => {
      axios
        .post(
          process.env.VUE_APP_upladHost +
            "/api/media/oss/upload?dir=" +
            obj.dir +
            "&saveFileName=" +
            (obj.saveFileName || ""),
          params
        )
        .then((response) => {
          // axios.post('http://192.168.0.81/api/media/upload_dir_img?dir='+obj.dir+'&saveFileName='+obj.saveFileName, params).then(response => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // uploadImg(params) {
  // 	params.random = Math.random();
  // 	return new Promise((resolve, reject) => {
  // 		axios.post(process.env.VUE_APP_upladHost+'/api/media/upload_img', params).then(response => {
  // 			resolve(response.data);
  // 		}).catch(err => {
  // 			reject(err)
  // 		})
  // 	})
  // },
  uploadFile(params) {
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_upladHost + "/api/media/upload_file", params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  print(params) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "https://account1.huashengchongwu.com/api/media/pos80_print",
          JSON.stringify(params)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  print_chufangjian(params) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "https://account1.huashengchongwu.com/api/media/chufangjian_print",
          JSON.stringify(params)
        )
        .then((response) => {
          // resolve(response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // .net
  upload_img_base64(params) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          "http://o2o.hscwhn.com:8020/api/media/upload_img_base64",
          params
        )
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getVipList(params) {
    return new Promise((resolve) => {
      let p = {
        hs_vip: -1, //花生会员：0否；1是；-1不限
        hs_pet: -1, //花生宠物：0否；1是；-1不限
        class_name: "", //类别  '' 犬类； 猫类
        field: "member", //搜索对象:顾客,手机号：member;宠物：pet
        keyword: params, //关键字
        pageIndex: 1,
        pageSize: 30,
        staff_type:"1,2,3"
      };
      axios.post(process.env.VUE_APP_Url_member+"/api/middleware/Member/List", p).then((res) => {
        resolve(res.data.data);
      });
    });
  },
  getPetList(params) {
    return new Promise((resolve) => {
      let p = {
        keyword: params, //关键字
      };
      axios.get("/api/Pet/List", p).then((res) => {
        resolve(res.data);
      });
    });
  },
  // 获取医生列表
  getDoctorList() {
    return new Promise((resolve) => {
      let params = {
        keyword: "", //关键字
        pageIndex: 1,
        pageSize: 200,
      };
      axios.get("/api/Staff/DoctorList", params).then((res) => {
        resolve(res.data.data);
      });
    });
  },
  // 获取员工列表
  getStaffList() {
    return new Promise((resolve) => {
      let params = {
        keyword: "", //关键字
        pageIndex: 1,
        pageSize: 500,
      };
      axios.get("/api/Staff/List", params).then((res) => {
        resolve(res.data.data);
      });
    });
  },
  // 获取品种列表
  getTypeList(petClass) {
    return new Promise((resolve) => {
      let params = {
        species: petClass || "犬类",
        keyword: "",
        pageIndex: 1,
        pageSize: 1000,
      };
      axios.post("/api/DataCenter/PetBreedList", params).then((res) => {
        resolve(res.data.data);
      });
    });
  },
  // 获取住院活动
  getZhuyuanList() {
    return new Promise((resolve) => {
      let params = {
        keyword: "",
        serviceTypeId: "5f0feb75ab24616b3fccb50e",
        categoryName: "住院",
        pageIndex: 1,
        pageSize: 1000,
      };
      axios.get("/api/Product/AllList", params).then((res) => {
        resolve(res.data.data);
      });
    });
  },
  // 获取用户信息
  getUserInfo(i) {
    return new Promise((resolve) => {
      let params = {
        id: i,
      };
      axios.get(process.env.VUE_APP_Url_member+"/api/middleware/Member/Single", params).then((res) => {
        resolve(res.data);
      });
    });
  },
  // 获取商品对应库存
  getGoodsInventory(goodsList, goodsType = 1) {
    let arr = [];
    if (!goodsList) {
      goodsList = [];
    }
    for (let i = 0; i < goodsList.length; i++) {
      let obj = {
        goodsId: goodsList[i].goodsId,
        goodsType: goodsType,
      };
      arr.push(obj);
    }
    return new Promise((resolve, reject) => {
      axios
        .post(process.env.VUE_APP_Url66 + "api/product/stock/list", {
          goodsIdList: arr,
        })
        .then((res) => {
          console.log(res, "res库存");
          for (let i = 0; i < res.data.length; i++) {
            goodsList[i].goodsName_a = res.data[i].goodsName;
            goodsList[i].stock_detail = res.data[i].skuStocks[0].lstStock;
            goodsList[i].skuStocks = res.data[i].skuStocks || [];
            goodsList[i].allow_wholesale = $public.isNull(
              res.data[i].allow_wholesale
            )
              ? 1
              : Number(res.data[i].allow_wholesale);
            goodsList[i].unit_changesrc = res.data[i].unit_changesrc;
            goodsList[i].unit_changedesc = res.data[i].unit_changedesc;
            goodsList[i].in_exchanage = res.data[i].in_exchanage;
            let kucun = 0;
            for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
              if (goodsList[i].skuStocks[a].skus === goodsList[i].skus) {
                for (
                  let b = 0;
                  b < goodsList[i].skuStocks[a].lstStock.length;
                  b++
                ) {
                  let aaa = goodsList[i].skuStocks[a].lstStock[b];
                  if (aaa.shopId === store.state.shopId) {
                    console.log(aaa, "aaa");
                    kucun = aaa.totalTimes;
                  }
                }
              }
            }
            if (Number(goodsList[i].goodsDosage) === 0) {
              // res.data[i].in_exchanage<1&&
              if (res.data[i].in_exchanage > kucun) {
                goodsList[i].goodsDosage = kucun;
              } else {
                goodsList[i].goodsDosage = res.data[i].in_exchanage;
              }
            }
          }
          console.log(goodsList, "goodsList111");
          resolve(goodsList);
        }).catch((err) => {
          reject(err);
        });
    });
  },
  // 获取商品所有规格和对应库存
  getGoodsInfo(goodsList, goodsType = 1) {
    console.log(goodsType,'goodsType');
    let arr = [];
    for (let i = 0; i < goodsList.length; i++) {
      let obj = {
        goodsId: goodsList[i].goodsId,
        goodsType: goodsType,
      };
      arr.push(obj);
    }
    return new Promise((resolve, reject) => {
      axios.post(process.env.VUE_APP_Url66 + "api/product/stock/list", {
          goodsIdList: arr,
        })
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            goodsList[i].goodsName_a = res.data[i].goodsName;
            goodsList[i].skuStocks = res.data[i].skuStocks || [];
            goodsList[i].allow_wholesale = $public.isNull(
              res.data[i].allow_wholesale
            )
              ? 1
              : Number(res.data[i].allow_wholesale);
            goodsList[i].unit_changesrc = res.data[i].unit_changesrc;
            goodsList[i].unit_changedesc = res.data[i].unit_changedesc;
            goodsList[i].in_exchanage = res.data[i].in_exchanage;
            let kucun = 0;
            for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
              if (goodsList[i].skuStocks[a].skus === goodsList[i].skus) {
                for (
                  let b = 0;
                  b < goodsList[i].skuStocks[a].lstStock.length;
                  b++
                ) {
                  let aaa = goodsList[i].skuStocks[a].lstStock[b];
                  if (aaa.shopId === store.state.shopId) {
                    console.log(aaa, "aaa");
                    kucun = aaa.totalTimes;
                  }
                }
              }
            }
            if (Number(goodsList[i].goodsDosage) === 0) {
              // res.data[i].in_exchanage<1&&
              if (res.data[i].in_exchanage > kucun) {
                goodsList[i].goodsDosage = kucun;
              } else {
                goodsList[i].goodsDosage = res.data[i].in_exchanage;
              }
            }
          }
          resolve(goodsList);
        }).catch((err) => {
          reject(err);
        });
    });
  },

    // 获取商品所有规格和对应库存
    getGoodsInfoCaigou(goodsList, goodsType) {
  if(goodsType==0){
      let arr = [];
      for (let i = 0; i < goodsList.length; i++) {
        let obj = {
          goodsId: goodsList[i].goodsId,
          goodsType: 0,
        };
        arr.push(obj);
      }
      return new Promise((resolve, reject) => {
        axios.post(process.env.VUE_APP_Url66 + "api/product/stock/list", {
            goodsIdList: arr,
          })
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {
              goodsList[i].goodsName_a = res.data[i].goodsName;
              goodsList[i].skuStocks = res.data[i].skuStocks || [];
              let lstStock = [];
              for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
                if (goodsList[i].skuStocks[a].skus === goodsList[i].skus) {
                  for (
                    let b = 0;
                    b < goodsList[i].skuStocks[a].lstStock.length;
                    b++
                  ) {
                    lstStock = goodsList[i].skuStocks[a].lstStock;
                   
                  }
                }
              }
            }
            resolve(goodsList);
          }).catch((err) => {
            reject(err);
          });
      })
     }
    },
  // 获取产品可参加的活动
  getActivityOfProduct(userInfo, goodsList, curPetInfo) {
    console.log(userInfo,"userInfo-------------------");
    if ($public.isNull(curPetInfo)) {
      curPetInfo = {};
      curPetInfo.hundred_assure = null;
      curPetInfo.medical_money = null;
    }
    let param_list = [];
    for (let i = 0; i < goodsList.length; i++) {
      console.log(goodsList[i],'goodsList[i];goodsList[i];goodsList[i];');
      let item = goodsList[i];
      if (item.goodsId === this.diffItemId) {
        param_list.push({
          param_id: "",
          param_sku_id: "",
          param_sku_name: "",
          brand: "", // 品牌id 只有商品接收此字段
          category_id: "", // 分类id
          packing_way_id: "", // 包装方式id
          custom_code: "", // 条码或宠物芯片
        });
      } else {
        param_list.push({
          param_id: item.goodsId || "",
          param_sku_id: item.skus || "",
          param_sku_name: item.skuValue || "",
          brand: item.brand || "", // 品牌id 只有商品接收此字段
          category_id: item.categoryId || "", // 分类id
          packing_way_id: item.unitId || "", // 包装方式id
          custom_code: "", // 条码或宠物芯片
        });
      }
    }
    let medical_param = 0;
    if (curPetInfo.hundred_assure && curPetInfo.hundred_assure.status === 1) {
      medical_param = 1;
    } else if (
      curPetInfo.medical_money &&
      curPetInfo.medical_money.status === 1
    ) {
      medical_param = 2;
    }
    let hs_master=0;
    if(userInfo.pet_count&&userInfo.pet_count.hsTotal>0){
      hs_master=1
    }else if(userInfo.pet_count&&userInfo.pet_count.hsTotal==0){
      hs_master=2
    }
    let params = {
      vipCardUser: userInfo.club_card.is_valid,
      staff_type: userInfo.staff_type, // 1在职  2.离职
      new_member: userInfo.isnew_member,
      user_id: userInfo._id,
      hs_master:hs_master,// 1在职  2.离职
      medical_param: medical_param, // 医疗选项 0 不限 1 百天保障 2 万元医疗
      param_list: param_list,
    };
    return new Promise((resolve) => {
      axios.post("/api/Activity/Product", params).then((r) => {
        if (r.code == 0) {
          resolve(r.data);
        }
      });
    });
  },
  getControllerForMember(userId) {
    let params = {
      memberId: userId, // 顾客id
      // "shopId": store.state.shopId,  // 门店id
      shopId: "5e9412e0b2bfbc089daerr15", // 门店id
    };
    return new Promise((resolve) => {
      axios
        .post(
          process.env.VUE_APP_Url_8020 +
            "/api/StaffMemberStatistic/GetSalesList",
          params
        )
        .then((r) => {
          if (r.code === 0) {
            resolve(r.data);
          }
        });
    });
  },
  //洗澡补差价
  diffItemX: {
    serviceId: "6347aae2fe1304b9a0ed2a64",
    need_contract: 0,
    title: "洗澡补差价",
    category_info: {
      _id: "605a8b32652fbf8339c22621",
      name: "补差价",
      code: null,
    },
    category_list: [
      {
        _id: "601d11cda93f55b5cf3ae2d1",
        name: "生活服务",
        code: "lifeservice",
      },
      { _id: "605a8b2c652fbf8339c22620", name: "项目补差价", code: null },
    ],
    keywords: ["补差价"],
    apply_type: { title: "通用", value: "0" },
    skuItem: {
      custom_discount: 1,
      min_price: 0,
      max_price: 0,
      frequency_code: "3",
      frequency_text: "次",
      weight_detail: { enable_weight_limit: 0, min_weight: 0, max_weight: 0 },
      use_goods: {
        must_use: 0,
        select_way: { title: "自选", value: "0" },
        select_num: 0,
        goods_list: [],
      },
      apply_varieties: {
        _id: "602dce523d5a0f7b8bfebbe0",
        name: "不限",
        code: "0",
      },
      apply_features: {
        _id: "602dce543d5a0f7b8bfebbe5",
        name: "不限",
        code: "0",
      },
      extend_attr: null,
      price: 1,
      originalPrice: 1,
      service_objectId: "605efaac8179d7f26789d012",
      service_objectName: "不限 不限",
    },
    serviceItems: [
      {
        custom_discount: 1,
        min_price: 0,
        max_price: 0,
        frequency_code: "3",
        frequency_text: "次",
        weight_detail: { enable_weight_limit: 0, min_weight: 0, max_weight: 0 },
        use_goods: {
          must_use: 0,
          select_way: { title: "自选", value: "0" },
          select_num: 0,
          goods_list: [],
        },
        apply_varieties: {
          _id: "602dce523d5a0f7b8bfebbe0",
          name: "不限",
          code: "0",
        },
        apply_features: {
          _id: "602dce543d5a0f7b8bfebbe5",
          name: "不限",
          code: "0",
        },
        extend_attr: null,
        mprice:0,
        price: 1,
        service_objectId: "605efaac8179d7f26789d012",
        service_objectName: "不限 不限",
      },
    ],
    join_commission: 1,
    shop_info: [
      {
        shop_id: "5e9412e0b2bfbc089daerr12",
        shop_name: "花生宠物4S店(金水区店)",
      },
      {
        shop_id: "5e9412e0b2bfbc089daerr14",
        shop_name: "花生宠物(指挥中心店)",
      },
      {
        shop_id: "5e9412e0b2bfbc089daerr17",
        shop_name: "花生宠物(线上旗舰店)",
      },
    ],
    app_shelves: 0,
    status: 1,
    operation_info: {
      create: {
        create_user: {
          user_id: "5f23aea1f69a9f5878c5a5e8",
          user_name: "宋亚磊",
        },
        create_time: "1616837292",
        create_from: null,
        create_ip: null,
        create_location: null,
      },
      update: {
        update_user: { user_id: null, user_name: null },
        update_time: null,
        update_content: null,
        update_ip: null,
        cupdate_location: null,
      },
      last_login: {
        last_login_time: null,
        last_login_ip: null,
        last_login_location: null,
      },
    },
    use_consumableMaterial_status: 0,
  },
  diffItemIdX: "6347aae2fe1304b9a0ed2a64",
  //美容补差价
  diffItemM: {
    serviceId: "6347aafbfe1304b9a0ed2acf",
    need_contract: 0,
    title: "美容补差价",
    category_info: {
      _id: "605a8b32652fbf8339c22621",
      name: "补差价",
      code: null,
    },
    category_list: [
      {
        _id: "601d11cda93f55b5cf3ae2d1",
        name: "生活服务",
        code: "lifeservice",
      },
      { _id: "605a8b2c652fbf8339c22620", name: "项目补差价", code: null },
    ],
    keywords: ["补差价"],
    apply_type: { title: "通用", value: "0" },
    skuItem: {
      custom_discount: 1,
      min_price: 0,
      max_price: 0,
      frequency_code: "3",
      frequency_text: "次",
      weight_detail: { enable_weight_limit: 0, min_weight: 0, max_weight: 0 },
      use_goods: {
        must_use: 0,
        select_way: { title: "自选", value: "0" },
        select_num: 0,
        goods_list: [],
      },
      apply_varieties: {
        _id: "602dce523d5a0f7b8bfebbe0",
        name: "不限",
        code: "0",
      },
      apply_features: {
        _id: "602dce543d5a0f7b8bfebbe5",
        name: "不限",
        code: "0",
      },
      extend_attr: null,
      price: 1,
      originalPrice: 1,
      service_objectId: "605efaac8179d7f26789d012",
      service_objectName: "不限 不限",
    },
    serviceItems: [
      {
        custom_discount: 1,
        min_price: 0,
        max_price: 0,
        frequency_code: "3",
        frequency_text: "次",
        weight_detail: { enable_weight_limit: 0, min_weight: 0, max_weight: 0 },
        use_goods: {
          must_use: 0,
          select_way: { title: "自选", value: "0" },
          select_num: 0,
          goods_list: [],
        },
        apply_varieties: {
          _id: "602dce523d5a0f7b8bfebbe0",
          name: "不限",
          code: "0",
        },
        apply_features: {
          _id: "602dce543d5a0f7b8bfebbe5",
          name: "不限",
          code: "0",
        },
        extend_attr: null,
        mprice:0,
        price: 1,
        service_objectId: "605efaac8179d7f26789d012",
        service_objectName: "不限 不限",
      },
    ],
    join_commission: 1,
    shop_info: [
      {
        shop_id: "5e9412e0b2bfbc089daerr12",
        shop_name: "花生宠物4S店(金水区店)",
      },
      {
        shop_id: "5e9412e0b2bfbc089daerr14",
        shop_name: "花生宠物(指挥中心店)",
      },
      {
        shop_id: "5e9412e0b2bfbc089daerr17",
        shop_name: "花生宠物(线上旗舰店)",
      },
    ],
    app_shelves: 0,
    status: 1,
    operation_info: {
      create: {
        create_user: {
          user_id: "5f23aea1f69a9f5878c5a5e8",
          user_name: "宋亚磊",
        },
        create_time: "1616837292",
        create_from: null,
        create_ip: null,
        create_location: null,
      },
      update: {
        update_user: { user_id: null, user_name: null },
        update_time: null,
        update_content: null,
        update_ip: null,
        cupdate_location: null,
      },
      last_login: {
        last_login_time: null,
        last_login_ip: null,
        last_login_location: null,
      },
    },
    use_consumableMaterial_status: 0,
  },
  diffItemIdM: "6347aafbfe1304b9a0ed2acf",
};
